import { useRef, useState } from 'react';
import { fulfillmentApi } from 'src/api/fulfillment';
import { setError } from 'src/slices/error';
import { setBackdrop } from 'src/slices/loading';
import SuccessMP3 from 'src/sounds/bell_long.mp3';
import ErrorMP3 from 'src/sounds/error.mp3';
import { useDispatch } from 'src/store';
import useSound from 'use-sound';

import { DocumentScanner } from '@mui/icons-material';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Theme,
    Tooltip,
    useMediaQuery,
} from '@mui/material';

const RedoLabelDailog = () => {
    const [successSound] = useSound(SuccessMP3);
    const [errorSound] = useSound(ErrorMP3);

    const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
    const [open, setOpen] = useState<boolean>(false);
    const [label, setLabel] = useState<string>('');
    const iframeRef = useRef(null);
    const textFieldRef = useRef(null);
    const dispatch = useDispatch();

    const handleOpen = (): void => {
        setOpen(true);
    };

    const handleClose = (): void => {
        setOpen(false);
    };

    const onChange = (event: any): void => {
        // detect enter key
        setLabel(event.target.value);
    };

    const onKeyDownEnter = (event: any): void => {
        if (event.key === 'Enter') {
            recreateLabel();
        }
    };

    const recreateLabel = async () => {
        try {
            dispatch(setBackdrop(true));
            const base64 = await fulfillmentApi.redoLabel(label);
            successSound();
            printDocument(base64);
        } catch (error) {
            dispatch(setError(error));
            errorSound();
        } finally {
            setLabel('');
            dispatch(setBackdrop(false));
        }
    };

    const printDocument = (base64Data: string) => {
        const blob = new Blob([Buffer.from(base64Data, 'base64')], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        iframeRef.current.src = url;
        iframeRef.current.onload = () => {
            iframeRef.current.contentWindow.print();
        };
    };

    return (
        <>
            <Tooltip title='Label Korrektur'>
                <IconButton color='inherit' size={mdUp ? 'large' : 'small'} onClick={handleOpen}>
                    <DocumentScanner />
                </IconButton>
            </Tooltip>

            <Dialog open={open} maxWidth='xl' fullWidth>
                <DialogTitle>Label Korrektur</DialogTitle>
                <DialogContent sx={{ m: 3 }}>
                    <TextField
                        ref={textFieldRef}
                        label='Scan'
                        onKeyDown={onKeyDownEnter}
                        fullWidth
                        variant='outlined'
                        autoFocus
                        value={label}
                        onChange={onChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='warning' onClick={handleClose}>
                        Schließen
                    </Button>
                </DialogActions>
            </Dialog>

            <iframe ref={iframeRef} style={{ display: 'none' }} title='print-pdf' />
        </>
    );
};

export default RedoLabelDailog;
